<template>
  <div>
    <SidebarToggler class="d-md-down-none" display="lg md" :defaultOpen=false />
    <div class="go-fix-logo">
      <router-link :to="`/`"><img class="lager" src="go-fix.png" alt="logo go fix"></router-link>
    </div>
    <Breadcrumb :list="listRoute"/>
    <div v-if="iframe.show_icon && pabx" class="float-left pabx_header_icon"><span @click="iframe.show_iframe =! iframe.show_iframe"><img src="/img/Phone_icon.png" alt=""></span></div>
    <div class="fixedChatBox" v-if="iframe.show_icon && pabx" :class="{active:iframe.show_iframe}">
      <iframe
          :src="iframe.src"
          allow="microphone; autoplay"
          width="100%"
          height="100%"
          scrolling="no"
      ></iframe>
      <div class="showData" @click="iframe.show_data = !iframe.show_data ">
        <span :class="{'icon-arrow-left': !iframe.show_data,'icon-arrow-right':iframe.show_data}"></span>
      </div>
      <div class="postMessageData" :class="{'active':iframe.show_data}">
        <b-tabs v-if="iframe.items.length">
          <b-tab :title="item.name || item.original_caller_id" v-for="(item, index) in iframe.items" active :key="index">
            <gofix-text-field class="mb-2" label="QueueName:" oneline>{{item.queue_name}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="OriginalCallerID:" oneline>{{item.original_caller_id}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="IVR:" oneline>{{item.ivr}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="DIDNumber:" oneline>{{item.did_number}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="Menu1:" oneline>{{item.menu_1}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="Menu2:" oneline>{{item.menu_2}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="Menu3:" oneline>{{item.menu_3}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="Pincode:" oneline>{{item.pincode}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="BuildingType:" oneline>{{item.building_type}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="FloorNumber:" oneline>{{item.floor_number}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="UnitNumber:" oneline>{{item.unit_number}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="ORINumber:" oneline>{{item.ori_number}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="AgentId:" oneline>{{item.agent_id}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="AwsConnectId:" oneline>{{item.aws_connect_id}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="Channel:" oneline>{{item.channel}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="Name:" oneline>{{item.name}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="Email:" oneline>{{item.email }}</gofix-text-field>
            <gofix-text-field class="mb-2" label="ContactNumber:" oneline>{{item.contact_number}}</gofix-text-field>
            <gofix-text-field class="mb-2" label="Address:" oneline>{{item.address }}</gofix-text-field>
            <gofix-text-field class="mb-2" label="Notes:" oneline>{{item.notes }}</gofix-text-field>
          </b-tab>
        </b-tabs>
        <div class="noItem" v-else>
          <span>No Data</span>
        </div>
      </div>
    </div>
    <div class="platforms-switch">
      <div>
        <b-dropdown right>
          <template v-slot:button-content>
            <img src="img/icon-application.png" alt="">
          </template>
          <b-dropdown-text class="list-platform">
            <div v-for="(platform, index) in platforms" class="item" :key="index">
              <a :href="isChangeRedirectCase(platform.reference_value_text, platform.reference_value_link)" target="_blank">
                <img :src="platform.reference_value_image" alt="">
                <span>{{platform.reference_value_text}}</span>
              </a>
            </div>
          </b-dropdown-text>
        </b-dropdown>
      </div>
    </div>
    <div class="dropdown-contract">
      <gofix-form-dropdown
              label=""
              class="gofixDropdownContractor gofixInputMinWith gofixDropdownBorder gofixInputNoBg"
              v-model="obj.data"
              :options="listSearch"
              :v-label="label"
              :filterable="false"
              @search="search"
              @change="input"
              :placeholder="placeholder"
      >
      </gofix-form-dropdown>
    </div>
    <div class="icon-next-select" v-bind:class="{'opacity-04': !obj.data }">
      <router-link class="editModal" :to="`/v2/contract-client/${obj.data.id}`" v-if="obj.data && obj.data.id">
        <img src="img/backIcon.png" alt width="25" height="25"/>
      </router-link>
      <img src="img/backIcon.png" alt width="25" height="25" v-else/>
    </div>
    <PasswordModal :show="is_show"/>
    <ResetPasswordModal :show="is_show_reset"/>
  </div>
</template>

<script>
import { Header as AppHeader, SidebarToggler } from '@coreui/vue'
const Breadcrumb = () => import('../breadcrumb/BreadcrumbV2')
const PasswordModal = () => import('../users/PasswordModal')
const ResetPasswordModal = () => import('../users/ResetPasswordModal')
import { mapGetters } from 'vuex';
export default {
  props: {
    listRoute: {
      type: Array,
      required: true,
      default: () => []
    },
    search: {
      type: Function,
      required: false
    },
    input: {
      type: Function,
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    listSearch: {
      type: Array,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    obj: {
      type: Object,
      required: false,
      default: () => ''
    },
    pabx: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  name: 'navigation-bar',
  components: {
    AppHeader,
    SidebarToggler,
    Breadcrumb,
    PasswordModal,
    ResetPasswordModal
  },
  data () {
    return {
      platforms:[],
      pwd_management:null,
      is_show:false,
      is_show_reset:false,
      iframe: {
        show_icon: false,
        show_iframe: false,
        show_data: false,
        src: 'https://nltcc.s3.ap-southeast-1.amazonaws.com/IFrame-UAT/index.htm',
        items:[],
        data:{
          QueueName: "" ,
          OriginalCallerID: "",
          IVR: "",
          DIDNumber: "",
          Menu1: "",
          Menu2: "",
          Menu3: "",
          Pincode: "",
          BuildingType:"" ,
          FloorNumber: "",
          UnitNumber: "",
          ORINumber: "",
          AgentId : "",
          AwsConnectId : "",
          Channel : "Voice/Chat",
          Name : "",
          Email : "",
          ContactNumber : "",
          Address : "",
          Notes : ""
        }
      },
    }
  },
  async created(){
    this.getPlatforms();
	  await this.checkPasswordExpired();
    this.checkShowPWReset();

  },
  computed: {
		...mapGetters({
			user : 'AuthController/user',
      ClientContractID: 'ContractController/ClientContractID',
		}),
  },
  watch: {
    user: function(val) {
      this.checkShowPWReset();
    },
    ClientContractID: function(val, old) {
      if (val && val.id){
        if (val.case_settings && val.case_settings.is_use_nlt_case_module){
          this.iframe.show_icon = true
          this.getAmazonConnectItems();
        }else{
          this.iframe.show_icon = false
        }
      }else{
        this.iframe.show_icon = false
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage)
  },
  methods:{
    getPlatforms(){
      let filter = {reference_type: "Source Application"};
      let params = {
        filter: filter,
        limit: -1,
        sortColumn: "reference_value_int"
      };
      this.$store.dispatch(`ReferenceController/getItems`, params)
        .then(response => {
          this.platforms = response.items;
        })
    },
	  async checkPasswordExpired(){
      await this.$store.dispatch(`v2UserController/checkPasswordExpired`, {})
        .then(response => {
          if(response.status){
            this.is_show = true
            return;
          }
          this.is_show = false
        })
        .catch(error => {
          console.log(error);
      })
    },
    checkShowPWReset() {
      this.is_show_reset = false
      if(this.user && this.user.is_first_login) {
        this.is_show_reset = true
      }
    },
     async receiveMessage(event){
      if(event.data.AwsConnectId ){
        this.iframe.data = event.data
        if(event.data.Direction === "Inbound" &&  event.data.OriginalCallerID && !this.iframe.show_iframe){
          this.iframe.show_iframe = true
        }
        let data = {
          queue_name: event.data.QueueName ? event.data.QueueName : null,
          original_caller_id: event.data.OriginalCallerID ? event.data.OriginalCallerID : null,
          ivr: event.data.IVR ? event.data.IVR : null,
          did_number: event.data.DIDNumber ? event.data.DIDNumber : null,
          menu_1: event.data.Menu1 ? event.data.Menu1 : null,
          menu_2: event.data.Menu2 ? event.data.Menu2 : null,
          menu_3: event.data.Menu3 ? event.data.Menu3 : null,
          pincode: event.data.Pincode ? event.data.Pincode : null,
          building_type: event.data.BuildingType ? event.data.BuildingType : null,
          floor_number: event.data.FloorNumber ? event.data.FloorNumber : null,
          unit_number: event.data.UnitNumber ? event.data.UnitNumber : null,
          ori_number: event.data.ORINumber ? event.data.ORINumber : null,
          agent_id: event.data.AgentId ? event.data.AgentId : null,
          aws_connect_id: event.data.AwsConnectId ? event.data.AwsConnectId : null,
          channel: event.data.Channel ? event.data.Channel : "Voice/Chat",
          name: event.data.Name ? event.data.Name : null,
          email: event.data.Email ? event.data.Email : null,
          contact_number: event.data.ContactNumber ? event.data.ContactNumber : null,
          address: event.data.Address ? event.data.Address : null,
          notes: event.data.Notes ? event.data.Notes : null
        }
        await this.$store.dispatch(`AmazonConnectController/saveItem`, data)
        await this.getAmazonConnectItems();
      }

    },

    getAmazonConnectItems(params = null){
      if (!params){
        params = {
          limit: 5,
          page:1,
          filter:{
            channel: 'chat',
          }
        }
      }
      this.$store.dispatch(`AmazonConnectController/getItems`, params)
              .then(response => {
                this.iframe.items = response.items.reverse()
              })
              .catch(err => {
                this.iframe.items =[]
              })
    },

    isChangeRedirectCase(val, link) {
	  if(this.user && 
	  	this.user.organization && 
		this.user.organization.is_supplier){
		 if(val == 'Supplier Portal')
		 	return link;
		return 'javascript:void(0);';
	  }
      let isCase = false;
      if(this.user && this.user.roles) {
        const arrTmp = this.user.roles.filter(item => item.name.toUpperCase() == 'NLT CSO')
        if(arrTmp.length) isCase = true;
      }
      if(val.toLowerCase() == 'cases' && isCase) 
	  	return '/#/case/list-opening';
	  if(val == 'Supplier Portal')
	  	return 'javascript:void(0);';
      return link;
    }
  }
}
</script>
